import { useTranslation } from 'next-i18next';
import { PersonStackFillIcon, SquareStackFillIcon, WhiteboardFillIcon } from '@/icons';
import { SECTION_PADDING } from '../constants';

/**
 * 수치(value)와 단위(unit)를 둘 다 번역 키로 둔다. 시안상 둘의 타이포가 달라
 * 한 문자열로 합칠 수 없고, 자릿수 체계가 로케일마다 달라서(ko "30"+"만 명"
 * vs en "300K"+"users") 수치를 코드에 박으면 영어에서 말이 안 된다.
 *
 * 단위는 "만 명"처럼 자릿수까지 포함한다 — 한국어의 만 단위가 영어엔 없어서
 * 쪼개 봐야 로케일별로 대응이 안 맞는다. 수치가 확정되면 코드가 아니라 시트의
 * value 행만 로케일별로 채우면 된다.
 */
const STATS = [{
  id: 'users',
  labelKey: 'boardLanding:stats.users.label',
  valueKey: 'boardLanding:stats.users.value',
  unitKey: 'boardLanding:stats.users.unit',
  icon: <PersonStackFillIcon className="size-[34px] text-white" />,
  badgeClassName: 'bg-green-500'
}, {
  id: 'boards',
  labelKey: 'boardLanding:stats.boards.label',
  valueKey: 'boardLanding:stats.boards.value',
  unitKey: 'boardLanding:stats.boards.unit',
  icon: <SquareStackFillIcon className="size-[34px] text-white" />,
  badgeClassName: 'bg-yellow-400'
}, {
  id: 'posts',
  labelKey: 'boardLanding:stats.posts.label',
  valueKey: 'boardLanding:stats.posts.value',
  unitKey: 'boardLanding:stats.posts.unit',
  icon: <WhiteboardFillIcon className="size-[34px] text-white" />,
  badgeClassName: 'bg-purple-500'
}] as const;
export function BoardLandingStats() {
  const {
    t
  } = useTranslation(['boardLanding']);
  return <section aria-label={t('boardLanding:stats.sectionLabel')} className={`flex flex-col items-center justify-center gap-xl min-[751px]:flex-row min-[1025px]:gap-3xl ${SECTION_PADDING}`} data-sentry-component="BoardLandingStats" data-sentry-source-file="BoardLandingStats.tsx">
      {STATS.map(stat => <div key={stat.id} className="flex items-center gap-md">
          <span aria-hidden="true" className={`flex size-[60px] shrink-0 items-center justify-center rounded-full ${stat.badgeClassName}`}>
            {stat.icon}
          </span>

          <div className="flex flex-col">
            <span className="text-body-lg-bold text-neutral opacity-60 min-[1025px]:text-heading-sm-bold">
              {t(stat.labelKey)}
            </span>
            <div className="flex items-end gap-[7px]">
              {/*
                모바일 40px 은 text-display-sm-extrabold 와 정확히 일치(ZUS 는
                ≤560px 에서 이 토큰을 30px 로 자동 축소하지 않는다 — display-sm 은
                이미 40px 이 모바일 값이다). 데스크톱 62px 은 토큰에 없다
                (display-md 는 48px) — 그대로 arbitrary value 로 남긴다.
               */}
              <strong className="text-display-sm-extrabold leading-[1] text-default min-[1025px]:text-[62px]">
                {t(stat.valueKey)}
              </strong>
              <span className="text-heading-md-bold text-neutral min-[1025px]:text-heading-lg-extrabold">
                {t(stat.unitKey)}
              </span>
            </div>
          </div>
        </div>)}
    </section>;
}